import { useState, useEffect, useRef } from "react";

export default function DatenblattEigenSidebar({ownerURL, ownerData }) {
   return (
      <>
         {ownerData.KdNr && (<table className="sidebar-table">
            <tbody>
               
                  <tr>
                     <td>KdNr:</td>
                     <td>
                        <a
                           target="_blank"
                           className="btn btn-outline-primary w-100 my-1"
                           rel="noopener noreferrer"
                           href={ownerURL}
                        >
                          {"⠀"}{ownerData.KdNr} ↗
                        </a>
                        
                     </td>
                  </tr>
                  <tr>
                     <td>Eigentümer:</td>
                     <td>
                        
                        {ownerData.Vorname} {ownerData.Name}
                        {/* <br />
                        {ownerData.Strasse} {ownerData.Hausnummer}
                        <br />
                        {ownerData.Plz} {ownerData.Ort} */}
                     </td>
                  </tr>
               
               {/* {ownerURL && (
                  <tr>
                     <td colSpan={2} style={{ textAlign: "center" }}>
                        <a
                           target="_blank"
                           className="btn btn-outline-primary  w-75 m-2"
                           rel="noopener noreferrer"
                           href={ownerURL}
                        >
                           oO Eigentümer ↗
                        </a>
                     </td>
                  </tr>
               )} */}
            </tbody>
         </table>)}
      </>
   );
}
